'use client';

import { iconCoinSmall } from '../../../../assets/images';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import FormValue from '../../../../components/form/FormValue/FormValue';
import IconTextUnit from '../../../../components/ui/IconTextUnit/IconTextUnit';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatCurrency } from '../../../../utils';

export interface PurchaseFinishProps {
  purchasedCoin: number;
  userCoin: number;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
}

function PurchaseFinish({ purchasedCoin, userCoin, actionButtonText, onActionButtonClick }: PurchaseFinishProps) {
  const isShowActionButton = !!actionButtonText && !!onActionButtonClick;

  const formattedPurchasedCoin = formatCurrency(purchasedCoin);
  const formattedUserCoin = formatCurrency(userCoin);

  return (
    <>
      <div className={utilsStyles.mtSmall}>
        <FormValue label={'購入内容'}>
          <div className={`${utilsStyles.centered} ${utilsStyles.spaceBetween}`}>
            <span>購入したコイン</span>
            <IconTextUnit text={formattedPurchasedCoin} imgSrc={iconCoinSmall.src} isUnitBold textSize='xLarge' />
          </div>
        </FormValue>
        <hr className={utilsStyles.pinkishgrayBgColor} />
      </div>
      <div className={utilsStyles.mtSmall}>
        <p className={utilsStyles.textSmall}>
          決済が完了しました。購入したコインを使用してイベントのくじを引くことができます。
        </p>
      </div>
      <div className={utilsStyles.mtSmall}>
        <FormValue label={''}>
          <div className={`${utilsStyles.centered} ${utilsStyles.spaceBetween}`}>
            <span>利用可能なコイン</span>
            <IconTextUnit text={formattedUserCoin} imgSrc={iconCoinSmall.src} isUnitBold textSize='xLarge' />
          </div>
        </FormValue>
        <hr className={utilsStyles.pinkishgrayBgColor} />
      </div>
      {isShowActionButton && (
        <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtSmall}`}>
          <ActionButton onClick={onActionButtonClick}>
            <span>{actionButtonText}</span>
          </ActionButton>
        </div>
      )}
    </>
  );
}

export default PurchaseFinish;
